import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/steam': {
    width: 496,
    height: 512,
    paths: [
      {
        d: 'M496 256C496 393 384.8 504 247.6 504 133.8 504 38 427.7 8.6 323.6L103.8 362.9C110.2 395 138.7 419.3 172.7 419.3 211.9 419.3 244.6 386.9 242.9 345.8L327.4 285.6C379.5 286.9 423.2 244.7 423.2 192.1 423.2 140.5 381.2 98.6 329.5 98.6S235.8 140.6 235.8 192.1V193.3L176.6 279C161.1 278.1 145.9 282.4 133.1 291.1L0 236.1C10.2 108.4 117.1 8 247.6 8 384.8 8 496 119 496 256zM155.7 384.3L125.2 371.7A52.8-52.8 0 0 1 152.4 397.5C179.3 408.7 210.2 395.9 221.4 369.1 226.8 356.1 226.9 341.8 221.5 328.8 216.1 315.8 206 305.6 193 300.2 180.1 294.8 166.3 295 154.1 299.6L185.6 312.6C205.4 320.8 214.8 343.5 206.5 363.3 198.2 383.2 175.5 392.5 155.7 384.3zM329.5 254.4C295.1 254.4 267.1 226.4 267.1 192.1S295.1 129.8 329.5 129.8 391.9 157.8 391.9 192.1 364 254.4 329.5 254.4zM329.6 238.8C355.5 238.8 376.5 217.8 376.5 192 376.5 166.1 355.5 145.2 329.6 145.2S282.7 166.2 282.7 192C282.8 217.8 303.8 238.8 329.6 238.8z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/brands/steam.js
// module id = KuuV
// module chunks = 144